export default {
  title: 'Commandes de téléconférence',
  starSharp2Title: 'Nombre d’appelants',
  starSharp2Body: 'Effectuer le suivi du nombre de participants à l’appel',
  starSharp3Title: 'Quitter la conférence',
  starSharp3Body:
    'Permet à l’animateur de raccrocher et de mettre fin à l’appel',
  starSharp4Title: 'Menu',
  starSharp4Body:
    'Permet d’écouter la liste de commandes du téléphone à clavier',
  starSharp5Title: 'Définir les modes d’écoute',
  starSharp5Body:
    'Appuyez une fois pour : Désactiver le micro des appelants; les appelants peuvent le réactiver en appuyant sur  *, #, 6\nAppuyez deux fois pour : Désactiver le micro des appelants; écoute seulement. Aucune option pour réactiver le micro\nAppuyez trois fois pour : Réactiver le micro des appelants; la ligne est de nouveau décrochée.',
  starSharp6Title: 'Act. mode disc. sur la ligne de l’animateur',
  starSharp6Body:
    'Appuyez une fois pour DÉSACTIVER le micro\nAppuyez de nouveau pour RÉACTIVER le micro',
  starSharp7Title: 'Sécuriser la conférence',
  starSharp7Body:
    'Appuyez une fois pour BLOQUER tous les appelants\nAppuyez de nouveau pour OUVRIR l’appel',
  starSharp8Title:
    'Entendre un son lorsque des participants entrent dans la téléconférence ou en sortent',
  starSharp8Body:
    'Appuyez une fois pour : DÉSACTIVER le son\nAppuyez deux fois pour : ACTIVER le son d’entrée et DÉSACTIVER le son de sortie\nAppuyez trois fois pour : DÉSACTIVER le son d’entrée et ACTIVER le son de sortie\nAppuyez quatre fois pour : ACTIVER le son',
  star9Title: 'Enregistrer la conférence',
  star9Body:
    'Appuyez une fois pour DÉMARRER l’enregistrement\nAppuyez de nouveau pour ARRÊTER l’enregistrement',
};

// @key: @#@"title"@#@ @source: @#@"Conference Commands"@#@
// @key: @#@"starSharp2Title"@#@ @source: @#@"Caller Count"@#@
// @key: @#@"starSharp2Body"@#@ @source: @#@"Keep track of how many people are on the call"@#@
// @key: @#@"starSharp3Title"@#@ @source: @#@"Leave Conference"@#@
// @key: @#@"starSharp3Body"@#@ @source: @#@"Lets the host hang up and end the call"@#@
// @key: @#@"starSharp4Title"@#@ @source: @#@"Menu"@#@
// @key: @#@"starSharp4Body"@#@ @source: @#@"Listen to the list of touchtone commands"@#@
// @key: @#@"starSharp5Title"@#@ @source: @#@"Set Listening Modes"@#@
// @key: @#@"starSharp5Body"@#@ @source: @#@"Press 1x: Mute callers - Callers can unmute with  *, #, 6\nPress 2x: Mute callers - Listen only. No unmuting option\nPress 3x: Unmute callers - Opens the line again"@#@
// @key: @#@"starSharp6Title"@#@ @source: @#@"Mute Host Line"@#@
// @key: @#@"starSharp6Body"@#@ @source: @#@"Press once to MUTE\nPress again to UNMUTE"@#@
// @key: @#@"starSharp7Title"@#@ @source: @#@"Secure the Call"@#@
// @key: @#@"starSharp7Body"@#@ @source: @#@"Press once to BLOCK all callers\nPress again to OPEN the call"@#@
// @key: @#@"starSharp8Title"@#@ @source: @#@"Hear sound when people Enter or Exit call"@#@
// @key: @#@"starSharp8Body"@#@ @source: @#@"Press 1x: Turns OFF sound\nPress 2x: Enter tone is ON Exit tone is OFF\nPress 3x: Enter tone is OFF Exit tone is ON\nPress 4x: Turns ON sound"@#@
// @key: @#@"star9Title"@#@ @source: @#@"Record your conference"@#@
// @key: @#@"star9Body"@#@ @source: @#@"Press once to START recording\nPress again to STOP recording"@#@
